const apiUrl = process.env.REACT_APP_API_URL;

/**
 * Duplicates a Conjunt de Pildores (practica + its cazas) into one or more aules.
 * Backend: POST /jutge/pildores/{id}/copy  body { aules: number[] }
 */
export const PostConjuntPildoresCopy = async (idConjunt: string, aules: number[], idUsuari?: string | number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/pildores/${idConjunt}/copy`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ aules, id_usuari: idUsuari != null ? Number(idUsuari) : undefined })
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al copiar el conjunt de pildores:', error);
        return null;
    }
};
